(() => {
// The Bleacher Crew – bridges app add-to-cart calls (Moon Bundle) to Horizon's cart drawer.
// Horizon only refreshes and auto-opens its drawer on its own CartLinesUpdateEvent; apps that
// post to /cart/add.js directly bypass it, so the drawer stays closed and stale.

const isAppAdd = (url) => /\/cart\/add\.js(\?|$)/.test(url);

function sectionIds() {
  return [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

async function syncDrawer(lines) {
  const { CartLinesUpdateEvent } = await import('@shopify/events');
  const ids = sectionIds();
  const deferred = CartLinesUpdateEvent.createPromise();
  document.body.dispatchEvent(
    new CartLinesUpdateEvent({ action: 'add', context: 'product', lines, promise: deferred.promise })
  );
  try {
    const [cart, sections] = await Promise.all([
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json()),
      ids.length
        ? fetch(`${location.pathname}?sections=${ids.join(',')}`).then((r) => r.json())
        : Promise.resolve({}),
    ]);
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'bc-cart-bridge',
        itemCount: lines.reduce((n, l) => n + (l.quantity || 1), 0),
        sections,
        didError: false,
      },
    });
  } catch (error) {
    deferred.reject(error);
  }
}

function linesFrom(body) {
  try {
    const data = typeof body === 'string' ? JSON.parse(body) : null;
    const items = data?.items || (data?.id ? [data] : []);
    return items.map((i) => ({ merchandiseId: String(i.id), quantity: Number(i.quantity) || 1 }));
  } catch {
    return [];
  }
}

const nativeFetch = window.fetch.bind(window);
window.fetch = async (input, init) => {
  const url = typeof input === 'string' ? input : input?.url || '';
  const response = await nativeFetch(input, init);
  if (isAppAdd(url) && response.ok) syncDrawer(linesFrom(init?.body));
  return response;
};

const nativeOpen = XMLHttpRequest.prototype.open;
const nativeSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open = function (method, url, ...rest) {
  this.__bcAppAdd = isAppAdd(String(url));
  return nativeOpen.call(this, method, url, ...rest);
};
XMLHttpRequest.prototype.send = function (body) {
  if (this.__bcAppAdd) {
    this.addEventListener('load', () => {
      if (this.status >= 200 && this.status < 300) syncDrawer(linesFrom(body));
    });
  }
  return nativeSend.call(this, body);
};

})();
